export default {
    name: 'Ism',
    tel: 'Telefon',
    save: 'Saqlash',
    confirm: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    delete: 'Oʻchirish',
    complete: 'Tugallash',
    loading: 'Yuklanmoqda...',
    telEmpty: 'Telefonni kiriting',
    nameEmpty: 'Ismingizni kiriting',
    nameInvalid: 'Yaroqli ismni kiriting',
    confirmDelete: 'Haqiqatan ham oʻchirib tashlamoqchimisiz',
    telInvalid: 'Toʻgʻri telefon raqamini kiriting',
    vanCalendar: {
        end: 'Tugash',
        start: 'Boshlash',
        title: 'Sarlavha',
        confirm: 'Tasdiqlash',
        startEnd: 'Boshlash Tugash',
        weekdays: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba'],
    },
    vanCascader: {
        select: 'Iltimos tanlang',
    },
    vanContactCard: {
        addText: 'Aloqani qoʻshish',
    },
    vanContactList: {
        addText: 'Yangi kontakt',
    },
    vanPagination: {
        prev: 'Oldingi sahifa',
        next: 'Keyingi sahifa',
    },
    vanPullRefresh: {
        pulling: 'Yangilash uchun torting...',
        loosing: 'Yangilash uchun qoʻyib yuboring...',
    },
    vanSubmitBar: {
        label: 'Hammasi:',
    },
    vanCoupon: {
        unlimited: 'Cheklovsiz foydalanish mumkin',
    },
    vanCouponCell: {
        title: 'Kupon',
        tips: 'Foydalanib boʻlmaydi',
    },
    vanCouponList: {
        empty: 'Kuponlar yoʻq',
        exchange: 'Almashish',
        close: 'Kuponlar yoʻq',
        enable: 'Mavjud',
        disabled: 'Foydalanib boʻlmaydi',
        placeholder: 'Kupon kodini kiriting',
    },
    vanAddressEdit: {
        area: 'Hudud',
        postal: 'Pochta indeksi',
        areaEmpty: 'Hududni tanlang',
        addressEmpty: 'Batafsil manzilni kiriting',
        postalEmpty: 'Pochta indeksi notoʻgʻri formatda',
        defaultAddress: 'Standart yetkazib berish manzili sifatida belgilang',
        telPlaceholder: 'Qabul qiluvchining telefon raqami',
        namePlaceholder: 'Qabul qiluvchining ismi',
        areaPlaceholder: 'Viloyat/shahar/tuman tanlang',
    },
    vanAddressEditDetail: {
        label: 'Manzil',
        placeholder: 'Koʻcha va uy raqami, qavat va xona raqami va boshqalar',
    },
    vanAddressList: {
        add: 'Manzil qoʻshish',
    },
};
